import React from 'react';

// OrderLab Logo Component
// Beaker/Flask with checkmark symbolizing validated orders

export const LogoIcon = ({ className = "w-8 h-8", color = "#1B4332" }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Beaker/Flask shape */}
    <path
      d="M14 8 L14 16 L10 28 C10 32 12 34 20 34 C28 34 30 32 30 28 L26 16 L26 8 Z"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    
    {/* Top opening of beaker */}
    <line x1="12" y1="8" x2="28" y2="8" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
    
    {/* Checkmark inside */}
    <path
      d="M15 20 L18 24 L25 16"
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    
    {/* Liquid level lines (optional detail) */}
    <line x1="12" y1="24" x2="28" y2="24" stroke={color} strokeWidth="1" strokeOpacity="0.3" />
  </svg>
);

export const Logo = ({ showText = true, size = "default", variant = "default" }) => {
  const sizeClasses = {
    small: "w-6 h-6",
    default: "w-8 h-8",
    large: "w-10 h-10"
  };
  
  const textSizeClasses = {
    small: "text-lg",
    default: "text-xl",
    large: "text-2xl"
  };
  
  const color = variant === "white" ? "#FFFFFF" : "#1B4332";
  const textColor = variant === "white" ? "text-white" : "text-[#1B4332]";

  return (
    <div className="flex items-center gap-2">
      <LogoIcon className={sizeClasses[size]} color={color} />
      {showText && (
        <span className={`${textSizeClasses[size]} font-bold ${textColor}`}>
          OrderLab
        </span>
      )}
    </div>
  );
};

export default Logo;
